export const FORMAT_WEEKDAY_FULL_DAY_MONTH_FULL_YEAR = 'weekday_full.day.month_full.year';
export const FORMAT_WEEKDAY_FULL_DAY_MONTH_FULL = 'weekday_full.day.month_full';
export const DAY_MONTH_ABBR = 'day.month_abbr';
export const FORMAT_WEEKDAY_MONTH_FULL_YEAR = 'weekday_month_full.year';

export const WEEKDAY_ABBR_DAY_MONTH_ABBR_YEAR_TIME = 'weekday_abbr.day.month_abbr.year.time';

export const FORMAT_DAY_MONTH_YEAR_NUMERIC = 'day.month.year_numeric';

export const PATTERN_TIME_12H = 'h:mm a';
export const PATTERN_TIME_24H = 'HH:mm';

const FORMATS = {
  [FORMAT_WEEKDAY_FULL_DAY_MONTH_FULL_YEAR]: {
    GB: 'dddd, D MMMM YYYY',
    AU: 'dddd, D MMMM YYYY',
    IE: 'dddd D MMMM YYYY',
    SG: 'dddd, D MMMM YYYY',
    CA: 'dddd, MMMM D YYYY',
    US: 'dddd, MMMM D YYYY',
  },
  [FORMAT_WEEKDAY_FULL_DAY_MONTH_FULL]: {
    GB: 'dddd, D MMMM',
    AU: 'dddd, D MMMM',
    IE: 'dddd D MMMM',
    SG: 'dddd, D MMMM',
    CA: 'dddd, MMMM D',
    US: 'dddd, MMMM D',
  },
  [FORMAT_WEEKDAY_MONTH_FULL_YEAR]: {
    GB: 'ddd, D MMM YYYY',
    AU: 'ddd, D MMM YYYY',
    IE: 'ddd D MMM YYYY',
    SG: 'ddd, D MMM YYYY',
    CA: 'ddd, MMM D YYYY',
    US: 'ddd, MMM D YYYY',
  },
  [DAY_MONTH_ABBR]: {
    GB: 'D MMM',
    AU: 'D MMM',
    IE: 'D MMM',
    SG: 'D MMM',
    CA: 'MMM D',
    US: 'MMM D',
  },
  [FORMAT_DAY_MONTH_YEAR_NUMERIC]: {
    GB: 'DD/MM/YYYY',
    AU: 'DD/MM/YYYY',
    IE: 'DD/MM/YYYY',
    SG: 'DD/MM/YYYY',
    CA: 'MM/DD/YYYY',
    US: 'MM/DD/YYYY',
  },
  [WEEKDAY_ABBR_DAY_MONTH_ABBR_YEAR_TIME]: {
    GB: 'ddd, D MMM YYYY, H:mm',
    AU: 'ddd, D MMM YYYY, h:mm a',
    IE: 'ddd D MMM YYYY, H:mm',
    SG: 'ddd, D MMM YYYY, H:mm',
    CA: 'ddd, MMM D YYYY, h:mm a',
    US: 'ddd, MMM D YYYY, h:mm a',
  },
};

export function formatDate(date, country, format) {
  if (!(date instanceof Date)) {
    throw new Error('Provided date is not an instance of Date object!');
  }

  if (!FORMATS[format]) {
    throw new Error(`Cannot find date format: "${format}"`);
  }

  if (!FORMATS[format][country]) {
    throw new Error(`Cannot find date format for country: "${country}"`);
  }

  return window.dayjs(date).format(FORMATS[format][country]);
}

export function getTimePattern(timeFormat) {
  if (timeFormat === 24) {
    return PATTERN_TIME_24H;
  }
  if (timeFormat === 12) {
    return PATTERN_TIME_12H;
  }

  throw new Error(`Invalid time format: "${timeFormat}"`);
}
